<template>
  <span v-if="!ObjectUtil.isEmpty(value)">
    <span :class="`zcurrency-currency ${currencyClass}`">{{ currency }}</span>&nbsp;
    <span :class="`zcurrency-number ${numberClass}`">{{ formatNumber(value) }} </span>
  </span>
</template>
<script>

import ObjectUtil from '../js/utils/ObjectUtil'

export default {
  name: 'Zcurrency',
  props: {
    currencyClass: { default: () => '' },
    numberClass: { default: () => '' },
    value: {},
  },
  data() {
    return {
      ObjectUtil,
      returnValue: null,
    }
  },
  computed: {
  },
  watch: {
    value(newVal) {
      this.returnValue = newVal
    },
    returnValue(newVal) {
      this.$emit('input', newVal)
    }
  },
  created() {

  },
  methods: {
  }
}
</script>
<style scoped>
</style>
